import * as _ from "lodash";
import * as log from "loglevel";
import { action, autorun, computed, observable, reaction, runInAction } from "mobx";
import { Agent } from "../services/agent";
import { EnumData } from "./models/enum-data";
import { User } from "./models/user";

export class UserStore{
	@observable loading = false;
	@observable saving = false;
	@observable mobileWarningShown = false;
	@observable users : User[] = [];

	contactTypes: EnumData[] = [];
	lastFetch: Date;

	@computed get externalUsers(): User[]{
		return this.users.filter(u => u.accountType === 1);
	}

	@computed get internalUsers(): User[]{
		return this.users.filter(u => u.accountType === 0);
	}

	@action async loadContactTypes(){
		let results = await Agent.Users.getContactTypes();
		runInAction(() => {
			this.contactTypes = results.map(res => { return new EnumData(res); });
		});
	}

	@action async loadUser(userId: string){
		try{
			this.loading = true;
			let userData = await Agent.Users.get(userId);
			runInAction(() => {
				let index = _.findIndex(this.users, {"id": userId});
				index > -1 ? this.users[index] = new User(userData) : this.users.push(new User(userData));
				this.loading = false;
			});
		}
		catch(err){
			runInAction(() => {
				this.loading = false;
			});
			throw err;
		}
	}

	@action async loadUsers(forceReload = false){
		try{
			this.loading = true;
			let userData = await Agent.Users.all();
			runInAction(() => {
				this.users = userData.map(data => {
					return new User(data);
				});
				this.loading = false;
			});
		}
		catch(err){
			runInAction(() => {
				this.loading = false;
			});
			throw err;
		}
	}

	@action async syncUsers(){
		this.loading = true;
		await Agent.Users.sync();
		runInAction(() => {
			this.loading = false;
		});
	}

	@action async purge(userId: string){
		await Agent.Users.purge(userId);
	}

	@action setMobileWarning(shown: boolean){
		this.mobileWarningShown = shown;
	}

	@action async changePassword(body) {
		await Agent.Users.changePassword(body);
	}

	findByUsername(username: string): User {
		return _.find(this.users.slice(), {"username": username});
	}

	findById(userId: string): User {
		return _.find(this.users.slice(), {"id": userId});
	}
}



// WEBPACK FOOTER //
// ./src/stores/user-store.ts